import { getInvalidConflicts } from '../../../../components/optional-ec-conflicts/conflicts-helpers';
import { isInactiveOptionType } from '../provider/helpers';

export {
  getInvalidConflictECsByEC,
  getUnviableConflictECs,
} from '../../../../components/optional-ec-conflicts/conflicts-helpers';

const getConflictEcList = (optionalECs) => {
  const ecList = [];
  optionalECs.forEach((cat) => {
    ecList.push(
      ...cat.data
        .filter(({ inputOptionType }) => !isInactiveOptionType(inputOptionType))
        .map(({ id, equipmentCode: ec, includes, excludes, requires }) => ({
          id,
          ec,
          includes: includes.value,
          excludes: excludes.value,
          requires: requires.value,
        })),
    );
  });
  return ecList;
};

// validate original conflicts
export const getInvalidConflictECs = (optECs) => {
  const conflictECs = getConflictEcList(optECs);
  return getInvalidConflicts(conflictECs);
};

// re-validate conflicts with updated field value
export const validateConflicts = (EC, field, value, optionalECs) => {
  const conflictECs = getConflictEcList(optionalECs);
  const ecIndex = conflictECs.findIndex(({ ec }) => ec === EC);
  conflictECs.splice(ecIndex, 1, {
    ...conflictECs[ecIndex],
    [field]: value,
  });
  return getInvalidConflicts(conflictECs);
};
